<h3 class="title">KALP</h3>

<div class="group-holder">
  <div class="subgroup-holder">

    @if (!loanService.application()?.kalpIncludingOtherProperties && !loanService.application()?.kalpExcludingOtherProperties) {
      <spb-kalp-item
        format="1.0-0"
        text="KALP"
        [value]="loanService.application()?.kalp"/>
    }

    @if (loanService.application()?.kalpIncludingOtherProperties) {
      <spb-kalp-item
        [textValue]="false"
        format="1.0-0"
        text="KALP inklusive existerande bostad"
        [value]="loanService.application()?.kalpIncludingOtherProperties"/>
    }

    @if (loanService.application()?.kalpExcludingOtherProperties) {
      <spb-kalp-item
        [textValue]="false"
        format="1.0-0"
        text="KALP exklusive existerande bostad"
        [value]="loanService.application()?.kalpExcludingOtherProperties"/>
    }

    <spb-kalp-item
      format="1.0-0"
      text="KALP endast existerande bostad"
      [value]="loanService.application()?.rawKalp"/>
  </div>
</div>